export default "__VITE_ASSET__CdBs2rVk__"